import { themeClasses } from '@member-portal/ui';
import AdvisorSignupForm from '@/components/advisor/AdvisorSignupForm';

function SignupPage() {
  return (
    <div className="fhxd-chrome-top">
      <section className="relative py-16 overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/images/seaside-2.jpg)' }}
        />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className={`${themeClasses.title.h1} !text-white mb-6`}>Advisor Sign Up</h1>
          <p className={`${themeClasses.text.body} !text-white/90 text-lg max-w-2xl mx-auto`}>
            Discover the FHxD world-class travel partner collection and earn more, faster.
            Registration is complimentary, with no obligation.
          </p>
        </div>
      </section>

      <AdvisorSignupForm />
    </div>
  );
}

export default SignupPage;
